// import { RebuildLoading } from '@/components/loading/RebuildLoading';
import { RebuildLoading } from "@/components/Loading/RebuildLoading";
import { useAuth } from "@/hooks/useAuth";
import { appSelector } from "@/redux/selectors/app.selector";
import { useSelector } from "@/redux/store";
// import { appSelector } from '@/redux/selectors/app.selector';
import { useEffect } from "react";
// import { useSelector } from 'react-redux';
import { useNavigate, useSearchParams } from "react-router-dom";

export const PasswordLess = () => {
  const navigate = useNavigate();

  const [searchParams] = useSearchParams();
  const { onSignIn, isAuthenticated } = useAuth();

  const email = searchParams.get("email");
  const loading = useSelector(appSelector.loading);

  useEffect(() => {
    if (!isAuthenticated) return;
    navigate("/dashboard");
  }, [isAuthenticated, navigate]);

  useEffect(() => {
    if (!email) return;

    onSignIn(email);
  }, [email, onSignIn]);

  return <> {loading && <RebuildLoading />} </>;
};
